module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_planner-be92a27bd70aac201e1e1fe66fee52f1.webp";